
import charleyslogo from '../assets/charleyslogo.png';



const images = {
  charleyslogo,
};

export default images;

